export enum ModalKeys {
  KYC,
  EDIT_USER,
  DELETE_USER,
  UPDATE_PHONE,
  ACCUMULATION,
  PASSWORD,
}
